import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { IonicVue } from '@ionic/vue'

import '@ionic/vue/css/core.css'
import '@ionic/vue/css/normalize.css'
import '@ionic/vue/css/structure.css'
import '@ionic/vue/css/typography.css'
import '@ionic/vue/css/padding.css'
import '@ionic/vue/css/float-elements.css'
import '@ionic/vue/css/text-alignment.css'
import '@ionic/vue/css/text-transformation.css'
import '@ionic/vue/css/flex-utils.css'
import '@ionic/vue/css/display.css'

import '@/styles/index.scss'

import App from './App.vue'
import router from './router'
import i18n from './i18n'

const setupMock = async () => {
  if (import.meta.env.DEV && import.meta.env.VITE_USE_MOCK === 'true') {
    await import('@/mock')
  }
}

const bootstrap = async () => {
  await setupMock()

  const app = createApp(App)

  app.use(createPinia())
  app.use(IonicVue)
  app.use(i18n)
  app.use(router)

  await router.isReady()
  app.mount('#app')
}

bootstrap()
